import apollo from '@/graphql'

import ProductsQuery from '@/graphql/product/ProductsQuery.gql'
import UnreviewedProductsQuery from '@/graphql/product/UnreviewedProductsQuery.gql'

// initial state
const state = {
  isProductLoading: false,
  products: [],
  total: 0,
  unreviewedEditableProductFields: [],
  unreviewedProducts: [],
}

// getters
const getters = {
  isProductLoading: st => st.isProductLoading,
  products: st => st.products,
  total: st => st.total,
  unreviewedEditableProductFields: st => st.unreviewedEditableProductFields,
  unreviewedProducts: st => st.unreviewedProducts,
}

// mutations
const mutations = {
  setIsProductLoading(st, isProductLoading) {
    state.isProductLoading = isProductLoading
  },

  setProducts(st, products) {
    state.products = products
  },

  setTotal(st, total) {
    state.total = total
  },

  setUnreviewedEditableProductFields(st, { context, unreviewedProducts }) {
    state.unreviewedEditableProductFields = unreviewedProducts.map((product) => {
      context.commit('setEditableProductFields', product)
      return context.getters.editableProductFields
    })

    context.commit('createProductDetails') // clear productDetails
  },

  setUnreviewedProducts(st, unreviewedProducts) {
    state.unreviewedProducts = unreviewedProducts
  },
}

// actions
const actions = {
  async loadProducts({ commit }, payload) {
    const variables = {
      search: '',
      offset: 0,
      limit: 10,
      sortBy: '',
      sortOrder: '',
      ...payload,
    }

    commit('setIsProductLoading', true)
    apollo.defaultClient.query({
      fetchPolicy: 'network-only',
      query: ProductsQuery,
      variables,
    }).then((result) => {
      const { products } = result.data
      commit('setProducts', products.list)
      commit('setTotal', products.filter.total)
    }).finally(() => {
      commit('setIsProductLoading', false)
    })
    // product list from backend is sorted by: vendor, category, brand, then name
  },

  loadUnreviewedProducts(context) {
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        query: UnreviewedProductsQuery,
      })
      .subscribe(({ data: { unreviewedProducts } }) => {
        const { commit } = context
        commit('setUnreviewedEditableProductFields', {
          context,
          unreviewedProducts,
        })
        commit('setUnreviewedProducts', unreviewedProducts)
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/product/ProductList.js